
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/designers/[uid]/[page]",
      function () {
        return require("private-next-pages/designers/[uid]/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/designers/[uid]/[page]"])
      });
    }
  